import { completeQuoteHeaderUploads } from 'src/app/views/dashboard/quote/quote-form-header/quote-header-upload';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { RfqCacheService } from '../../dashboard/rfq-cache.service';
import { FormBuilder, FormControl, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BuyerService } from 'src/app/views/settings/buyers/buyer.service';
import { Page } from 'src/app/shared/models/page';
import { SettingsService } from 'src/app/views/settings/settings.service';
import { ServiceRfqTokenAuthService } from 'src/app/shared/services/service-rfq-token-auth.service';
import { Observable, from } from 'rxjs';
import { AutoCompleteDataType, Currency, incoterms, offeredQuality, portData, quoteAttachmentType, supplierBranchData, Vessel } from 'src/app/shared/models/settings.model';
import { v4 as uuidv4 } from "uuid";
import { NgxFileDropEntry } from 'ngx-file-drop';
import { AttachmentTypes } from 'src/app/shared/common/Enums';
import { AwsSdkService } from 'src/app/shared/services/aws-sdk.service';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { MatRadioChange } from '@angular/material/radio';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { RfqGenerateFormService } from '../../dashboard/rfq/rfq-generate-form/rfq-genearte-form.service';
import { QuoteService } from '../../dashboard/quote/quote.service';
import { SupplierService } from 'src/app/views/settings/suppliers/supplier.service';
import { DataTransferService } from 'src/app/shared/services/data-transfer.service';

import moment from 'moment';

interface Attachment {
  name: string;
  systemName: string;
  fileKey: string;
  s3_path: string;
}

interface Countries {
  name: string;
  code: string;
  dialcode: string;
  currency: string;
  flag:string;
}

interface Location {
  locationId: number;
  locationName: string;
  code: string;
}

interface Incoterm {
  incotermId: number;
  incotermCode: string;
  userId: number;
  locationDetails: Location[];
}

@Component({
  // Issue 7 — force Material form-field labels on this screen to float to
  // the top so they never rest over / overlap the input value.
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always' } },
  ],
  selector: 'app-service-rfq-token-quote-form-header',
  templateUrl: './serviceQuoteFormHeader.component.html',
  styleUrls: ['./serviceQuoteFormHeader.component.css']
})


export class ServiceRfqTokenQuoteFormHeaderComponent implements OnInit{


  firstFormGroup!: UntypedFormGroup;


  isForm1Expand: boolean = true;
  isForm2Expand: boolean = true;
  isForm3Expand: boolean = true;
  isForm4Expand: boolean = true;
  isForm5Expand: boolean = true;
  isForm6Expand: boolean = true;
  isForm7Expand: boolean = true;
  isForm8Expand: boolean = true;

  headerData:any;
  showConfirmationDialogue: boolean = false
  showSuccessDialogue: boolean = false
  showCloseDialogue: boolean = false;

  showNotification: boolean = false;
  notificationMessage: string = '';
  notificationTitle: string = '';
  notificationType: 'error' | 'info' = 'error';


  tabs: any[] = [
    {
      index: 0,
      label: 'LINE ITEMS',
      icon: "directions_boat",
      route: 'line-items',
    },
    {
      index: 1,
      label: 'HEADER DETAILS',
      icon: "looks",
      route: 'header',
    },
    {
      index: 2,
      label: 'PAYMENT TERMS',
      icon: "location_searching",
      route: 'payment-terms',
    },{
      index:3,
      label: 'PREVIEW',
      icon: "location_searching",
      route: 'preview',
    }
  ];

  currentTab: string = 'header';
  serviceRfqId!:number
  quoteId!:any
  isSaved: boolean = false;
  lastId!: number;
  tabEnabled: boolean = false;
  showDetailSection: boolean = false;
  headerAttachmentUrl:any;
  headerAttachmentSection:boolean=false;
  supplierAttachmentUrls:string[]=[];
  supplierAttachmentsSection:boolean=false;
  supplierCurrentIndex:number=0;
  paymentTermsAndConditionsSection:boolean=false;
  buyerAttachmentsSection:boolean=false;
  paymentTermsAndConditions:any;
  paymentTermsAndConditionAttachmentUrl:any;
  buyerAttachmentUrl:string[]=[];
  currentIndex = 0;

  incoterms:incoterms[]=[]
  offeredQualityData:offeredQuality[]=[]
  headerAttachmentType:quoteAttachmentType[]=[]
  lineItemAttachmentType:quoteAttachmentType[]=[]

  boundGetCurrencyAutoComplete!: (pageMeta: Page) => Observable<any>;
  boundGetCountryAutoComplete!: (pageMeta: Page) => Observable<any>;

  filterFieldCountryNameDisplayFn(_country: AutoCompleteDataType) {
    return _country ? `${_country.name}` : undefined;
  }
  searchKeyParams: string = '';

  showAddDocumentSection:boolean=false

  selectedAttachmentType!:number |null
  newfileuploaded:boolean=false;
  uploadedAttachmentsArray: any[] = [];
  acceptedAttachmentExtenstion: any = ['.pdf', '.jpg', '.jpeg', '.png'];
  maxFileSize: number = 10 * 1024 * 1024; //10MB
  delAttachmentArr:number[] = [];
  minDate=new Date()
  maxDate=new Date()


  declineReason:string = ''
  showDeclineConfirmationDialogue:boolean=false

  countryControl: FormControl = new FormControl();
  countries: any[] = [];
  filteredCountries: any[] = [];
  selectedCountries: any[] = [];
  incotermLocationList:any[]=[]

  constructor(
    private snack: MatSnackBar,
    private rfqCacheService: RfqCacheService,
    private _formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private BuyerService: BuyerService,
    private router: Router,
    private SettingsService: SettingsService,
    private fb: FormBuilder,
    private awsSdkService: AwsSdkService,
    private webApiService: WebApiService,
    private ls: LocalStoreService,
    private fullLoaderService: FullLoaderService,
    private activatedRoute: ActivatedRoute,
    private RfqGenerateFormService:RfqGenerateFormService,
    private serviceRfqTokenAuth: ServiceRfqTokenAuthService,
    private quoteService: QuoteService,
    private supplierService:SupplierService,
    private dataTransferService: DataTransferService<any>

  ) {
  };


  async ngOnInit() {

    this.fullLoaderService.showLoader();
    this.boundGetCurrencyAutoComplete =
      this.getCurrencyFilterKeyDataObservable.bind(this);

    this.firstFormGroup = this._formBuilder.group({

      // quote details
      quoteId: [null],
      serviceRfqId: [null],
      quoteRefNumber: [null],
      serviceSupplierRfqDetailsId:[null],
      quoteDate: [new Date()],
      priceGoodUntilDate: [null],
      offeredQuality: [null],
      onTimeDeliveryOrderDate: [null],
      quotedDeliveryInDays: [null],

      // incoterms details
      incoterms: [null],
      incotermLocation: [null],

      // my details
      supplierId: [null],
      supplierContactName: [''],
      supplierEmail: [null],
      supplierTelephone: [null],
      supplierMobile: [null],
      supplierCompanyEmail: [null],
      supplierCurrency: [null],

      // comment
      supplierComment: [null],
      buyerComment: [null],
      quoteHeaderAttachmentType:[null],
      quoteHeaderAttachments:[null],

      // freight forwarder
      quoteFreightForwarderId: [null],
      freightForwarderDetailsId : [null],
      freightForwarderCompanyName: [null],
      pic : [null],
      freightForwarderJobTitle : [null],
      freightForwarderEmailId : [''],
      freightForwarderPhone : [null],
      freightForwarderFax : [null],
      freightForwarderAddress : [null],
      packaging : [null],
      modeOfTransport : [null]


    });


    this.boundGetCountryAutoComplete = this.getCountryFilterKeyDataObservable.bind(this)


    this.incoterms =  await this.quoteService.fetchAllIncotermsByServiceRfqToken();
    this.incotermLocationList = await this.quoteService.fetchAllIncotermsBySupplierIdByServiceRfqToken();
    console.log("incoterLocationList",this.incotermLocationList);
    if(this.incotermLocationList?.length){
      this.onIncotermSelected(this.incotermLocationList[0].incotermId)
    }


    this.offeredQualityData = await this.quoteService.fetchAllOfferedQualityByServiceRfqToken();
    this.headerAttachmentType = await this.quoteService.fetchAllQuteAttachmentTypeByServiceRfqToken('QuoteHeaderAttachmentType');
    this.countries = await this.quoteService.fetchAllCountryDetailsByServiceRfqToken();

    console.log("countries List",this.countries);


    this.activatedRoute.queryParams.subscribe(async params => {


      if (params['serviceRfqId'] != '' && params['quoteId'] != '' ) {

        this.serviceRfqId = params['serviceRfqId']
        this.quoteId = params['quoteId']


        if (this.quoteId != 'new') {

          this.isSaved = true
          await this.getQuoteDraftData()

        }
        else if (this.quoteId == 'new') {

          this.fullLoaderService.showLoader()
          console.log("visited for new quotation with serviceRfqId and getting userId by cookies",Number(this.serviceRfqTokenAuth.getSupplierId()));
          this.quoteService.getSupplierUpdateDataByServiceRfqToken()
            .then((data) => {
              this.firstFormGroup.patchValue({

                supplierId: Number(this.serviceRfqTokenAuth.getSupplierId()),
                supplierContactName:  data.data[0].companyName,
                supplierEmail: data.data[0].primaryEmail,
                supplierTelephone: data.data[0].phone1,
                supplierMobile: data.data[0].phone1,
                supplierCompanyEmail: data.data[0].primaryEmail,
                supplierCurrency: [null]

              });

            })
          this.loadData()
          this.fullLoaderService.hideLoader()
        }

        this.fetchServiceRfqDetails()

      }


    })

  }


    // fetch last quote id
    async loadData() {
      try {

        this.fullLoaderService.showLoader()

        const data = await this.quoteService.getLastServiceQuoteIdByServiceRfqToken();
        this.lastId = data[0]?.lastId || 0;

        this.firstFormGroup.patchValue(
          {
            quoteRefNumber: 'SQ-VSMPS-' +
              new Date().getFullYear().toString() +
              String(new Date().getMonth() + 1).padStart(2, '0') +
              String(new Date().getDate()).padStart(2, '0') +
              '-' + (this.lastId + 1)
          }
        )

        this.fullLoaderService.hideLoader()


      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    async fetchServiceRfqDetails(){
      this.fullLoaderService.showLoader()
      let paramsData = {serviceRfqId:this.serviceRfqId, supplierId:Number(this.serviceRfqTokenAuth.getSupplierId())}
      const data = await this.quoteService.fetchServiceRfqDetailsByServiceRfqToken(paramsData)
      this.headerData = data.rfqData[0];
      console.log("Header Data ",this.headerData);

      // Nest vessel data into a vessel object to match HTML template bindings
      this.headerData.vessel = {
        vesselName: this.headerData.vesselName,
        imoNumber: this.headerData.vesselImoNumber,
        typeOfVessel: this.headerData.vesselType,
        class: this.headerData.vesselClass,
      };

      // Nest currency data to match HTML template bindings
      this.headerData.currencyId = {
        currencyCode: this.headerData.currencyCode,
        currencyName: this.headerData.currencyName,
      };

      this.firstFormGroup.patchValue(
        {
          serviceSupplierRfqDetailsId: this.headerData.supplierRfqId
        }
      )
      this.fullLoaderService.hideLoader()
    }

  filterCountries(searchText: string): any[] {
    const filterValue = searchText.toLowerCase();
    return this.countries.filter((country) =>
      country.name.toLowerCase().includes(filterValue)
    );
  }


  onInputChange(searchText: string): void {
    this.filteredCountries = this.filterCountries(searchText || '');

    const selectedCountriesSet = new Set(this.selectedCountries.map((country) => country.id));

    this.filteredCountries.sort((a, b) => {
      const aSelected = selectedCountriesSet.has(a.id) ? 1 : 0;
      const bSelected = selectedCountriesSet.has(b.id) ? 1 : 0;
      return bSelected - aSelected;
    });
  }

  isCountrySelected(country: any): boolean {
    return this.selectedCountries.some(selected => selected.id === country.id);
  }

  onCheckboxChange(event: any, country: any): void {
    if (event.checked) {
      this.selectedCountries.push(country);
    } else {
      this.selectedCountries = this.selectedCountries.filter(selected => selected.id !== country.id);
    }

    const selectedCountriesSet = new Set(this.selectedCountries.map((country) => country.id));

    this.filteredCountries.sort((a, b) => {
      const aSelected = selectedCountriesSet.has(a.id) ? 1 : 0;
      const bSelected = selectedCountriesSet.has(b.id) ? 1 : 0;
      return bSelected - aSelected;
    });

    this.firstFormGroup.get('incotermLocation')?.setValue(this.selectedCountries.map(c => c.id));
  }

  getSelectedCountries(): string {
    return this.selectedCountries.map(country => country.name).join(', ');
  }

  onIncotermSelected(incotermId:Number): void {
    const matchingIncoterm = this.incotermLocationList.find(
      (item: any) => item.incotermId === incotermId
    );
    console.log({matchingIncoterm});
    if(matchingIncoterm){
      this.firstFormGroup.patchValue({
          incoterms: matchingIncoterm.incotermId,
          incotermLocation: matchingIncoterm.locationDetails.map((loc: Location) => loc.locationId),
        });

      this.selectedCountries = matchingIncoterm.locationDetails.map((loc: Location) => ({
          id: loc.locationId,
          name: loc.locationName
      }));

    }else{
      console.log("setting the selected incoterms....")
      this.firstFormGroup.get('incoterms')?.setValue(incotermId);
      this.firstFormGroup.get('incotermLocation')?.reset();
      this.selectedCountries=[];
    }

    console.log("incotermId",this.firstFormGroup.get('incoterms')?.value);
  }

  dismissNotification() {
    this.showNotification = false;
  }

showMissingFieldsNotification(missingFields: { section: string, fields: string[] }[]) {
  console.log("showMissingFieldsNotification function is called...")
  let message = '<strong>Please fill all the missing fields before proceeding:</strong><br><br>';

  missingFields.forEach(missingField => {
    message += `<strong>${missingField.section}:</strong><br>`;
    message += missingField.fields.map(field => `  • ${field}`).join('<br>');
    message += '<br><br>';
  });

  console.log({message});
  this.notificationMessage = message;
  this.notificationTitle = 'Missing Fields';
  this.notificationType = 'error';
  this.showNotification = true;
}


  isValidRequiredFields(): { section: string, fields: string[] }[] {
    console.log("isValidRequiredFields is called in service quote header")
    const missingFields: { section: string, fields: string[] }[] = [];

    const headerMissingFields: string[] = [];
    const form = this.firstFormGroup;

    if (!form.get('offeredQuality')?.value) {
      headerMissingFields.push('Offered Quality');
    }
    if (!form.get('onTimeDeliveryOrderDate')?.value) {
      headerMissingFields.push('On Time Delivery Order Date');
    }

    if (!form.get('priceGoodUntilDate')?.value) {
      headerMissingFields.push('Price Good Until Date');
    }

    if (headerMissingFields.length > 0) {
      missingFields.push({ section: 'Header Details', fields: headerMissingFields });
    }

    if (missingFields.length > 0) {
      this.showMissingFieldsNotification(missingFields);
    }

    return missingFields;
  }

  async save(isDraft?:boolean){

    if(isDraft){
      this.showConfirmationDialogue = false;
      this.showCloseDialogue = false;
    }else{
      const missingFields = this.isValidRequiredFields();
      if(missingFields.length>0){
        console.log({missingFields})
        return;
      }
    }

    this.fullLoaderService.showLoader()

    const dateString1 = this.firstFormGroup.value.quoteDate ? moment(this.firstFormGroup.value.quoteDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
    const dateString2 = this.firstFormGroup.value.priceGoodUntilDate ? moment(this.firstFormGroup.value.priceGoodUntilDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
    const dateString3 = this.firstFormGroup.value.onTimeDeliveryOrderDate ? moment(this.firstFormGroup.value.onTimeDeliveryOrderDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;



      this.firstFormGroup.patchValue({
        quoteDate: dateString1,
        priceGoodUntilDate: dateString2,
        onTimeDeliveryOrderDate: dateString3
      });

      let attachmentFiles:any = {}
      let formObj = this.firstFormGroup.value
      let attachmentArray = [...this.uploadedAttachmentsArray]

      attachmentArray = attachmentArray.filter(item=>item.file)

      // 2026-10-26: the quote reference shown here is the browser's guess (the server assigns the real one on save), so it can
      // name ANOTHER supplier's quote; header files go to a fresh folder of their own. The saved attachment rows decide who
      // may open them (Supplier-API utils/file-access.js).
      let uploadPath = `quotation/upload-${uuidv4()}`

      await Promise.all(attachmentArray.map(async(attachment:any,index:any)=>{
        if(!attachment.file){
              return
        }

            let fileName = attachment.file.name
            let fileExt = attachment.name.slice(
              ((attachment.name.lastIndexOf('.') - 1) >>> 0) + 2
            );

            let fileNameSystem = `${uuidv4()}.${fileExt}`

            attachment.systemName = fileNameSystem
            let s3Location = `${uploadPath}/${fileName}`;

            let _s3Params = {
              fileKey: s3Location,
              fileContentType: (<File>attachment.file).type,
            };
            attachment.s3Params = _s3Params
            attachmentFiles[attachment.file.name] = attachment.file
      }))

          console.log({attachmentArray});
          try {
            const signed = await this.quoteService.getBulkAttachmentUrlsByServiceRfqToken(attachmentArray);
            const uploaded = await completeQuoteHeaderUploads(attachmentArray, signed,
              (url, file) => this.webApiService.putRequestExternalApi(url, file),
              url => this.awsSdkService.extractS3LocationFromUrl(url));
            const saved = this.uploadedAttachmentsArray.filter((item: any) => item && !item.file);
            this.firstFormGroup.get('quoteHeaderAttachments')?.setValue([...saved, ...uploaded]);
          } catch (error) {
            this.fullLoaderService.hideLoader();
            this.snack.open('Attachment upload failed. Please retry.', 'OK', { duration: 5000 });
            return;
          }

        console.log("quoteHeaderAttachments",formObj.quoteHeaderAttachments);


      const params = {
        section: 'tab1',
        isDraft: isDraft,
        quoteId: this.quoteId,
        quoteStatus: isDraft? 14 : 2,
        tabId: 2,
        headerDetails: this.firstFormGroup.value,
        serviceRfqId: this.serviceRfqId
      };

      console.log("Saving firstFormGroup value....",this.firstFormGroup.value);




      if (this.quoteId == 'new' && this.firstFormGroup.get('quoteId')?.value == null) {



        const result = await this.quoteService.saveServiceQuoteAsDraftByServiceRfqToken(params);


        if (result?.data) {

          this.fullLoaderService.hideLoader()

          this.snack.open(`Header Data Saved`, "OK", { duration: 3000 });

          this.isSaved = true;

          this.quoteId = result.data

          this.next()


        } else {
          this.fullLoaderService.hideLoader()
          throw new Error('Invalid response format: Expected { data: number }');
        }

      }
      else if (this.quoteId != 'new' &&
        this.firstFormGroup.get('quoteFreightForwarderId')?.value

      ) {

        const result = await this.quoteService.updateServiceQuoteDraftByServiceRfqToken(params);

        if (result?.data) {

          this.fullLoaderService.hideLoader()

          this.snack.open(`Header Data Saved`, "OK", { duration: 3000 });

          this.isSaved = true;

          if(isDraft){
            this.router.navigate(['/serviceRfqToken/rfqDetails', this.serviceRfqId]);
          }


        } else {
          this.fullLoaderService.hideLoader()
          throw new Error('Invalid response format: Expected { data: number }');
        }

      }

  }

  async close(isDraft: boolean) {
    if (!isDraft) {
      this.showConfirmationDialogue = true
    }
    else {
      this.showCloseDialogue = true

    }

  }

  cancel() {
    this.showConfirmationDialogue = false
    this.showCloseDialogue = false
  }


  next(){

    if (this.isSaved) {

      this.activatedRoute.queryParams.subscribe(async params => {

        if (params['serviceRfqId'] != '' && params['quoteId'] != '') {

          this.serviceRfqId = params['serviceRfqId']
          const quoteId = this.quoteId

          this.router.navigate([
            '/serviceRfqToken/quote-payment-terms'
          ],
            {
              queryParams: { serviceRfqId: this.serviceRfqId, quoteId: quoteId }
            }
          );

        }

      })
    }
    else{
      this.snack.open(`please save the 'Header' tab first`, "OK", { duration: 3000 });
    }
  }

  async back() {

    this.activatedRoute.queryParams.subscribe(async params => {


      if (params['serviceRfqId'] != '' && params['quoteId'] != '' ) {

        this.serviceRfqId = params['serviceRfqId']
        this.quoteId = params['quoteId']


        this.router.navigate([
          '/serviceRfqToken/quote-line-items'
        ],
          {
            queryParams: { serviceRfqId: this.serviceRfqId, quoteId:this.quoteId }
          }
        );

    }})


  }

  toggleShowHeaderDetails(event: { checked: boolean }) {
    this.showDetailSection = event.checked;
  }
  toggleVisibility(section: string) {
    if (section == 'form1') {
      this.isForm1Expand = !this.isForm1Expand
    }
    else if (section == 'form2') {
      this.isForm2Expand = !this.isForm2Expand
    }
    else if (section == 'form3') {
      this.isForm3Expand = !this.isForm3Expand
    }
    else if (section == 'form4') {
      this.isForm4Expand = !this.isForm4Expand
    }
    else if (section == 'form5') {
      this.isForm5Expand = !this.isForm5Expand
    }
    else if (section == 'form6') {
      this.isForm6Expand = !this.isForm6Expand
    }
    else if (section == 'form7') {
      this.isForm7Expand = !this.isForm7Expand
    }
    else if (section == 'form8') {
      this.isForm8Expand = !this.isForm8Expand
    }

  }


  async selectMatTabLink(tabItem: any) {

    if(this.showNotification)return;
    if(tabItem.route == 'line-items'){

        await this.saveDraft();
        this.back()

    }
    else if(tabItem.route == 'payment-terms'){

      const missingFields = this.isValidRequiredFields();

      if(missingFields.length>0){
        console.log({missingFields})
        return;
      }

      await this.save(false);

      if(this.isSaved){

       this.next()

      }
      else{
        this.snack.open(`please save the 'Header' tab first`, "OK", { duration: 3000 });
      }
    }else if(tabItem.route == 'preview'){

      const missingFields = this.isValidRequiredFields();

      if(missingFields.length>0){

        return;
      }

      await this.save();

      if(this.isSaved){

       this.activatedRoute.queryParams.subscribe(async params => {

          if (params['serviceRfqId'] != '' && params['quoteId'] != '') {

            this.serviceRfqId = params['serviceRfqId']
            this.quoteId = params['quoteId']

            this.router.navigate([
              '/serviceRfqToken/quote-preview'
            ],
              {
                queryParams: { serviceRfqId: this.serviceRfqId, quoteId: this.quoteId }
              }
            );

          }

        })

      }
      else{
        this.snack.open(`please save the 'Header' tab first`, "OK", { duration: 3000 });
      }
    }
  }

  async checkisTabEnabled() {

    const data2 = await this.quoteService.getServiceQuoteDraftDataByServiceRfqToken('tab2', this.quoteId)

    if (data2 && data2.length > 0 && Object.keys(data2[0]).length > 0 && data2[0].rfqLineItemDetails.length > 0) {

      this.tabEnabled = true

    }

  }

  async onAddtionalFileSelected(files: NgxFileDropEntry[]) {
    try {
    } catch (error: any) {
      this.snack.open(error, 'OK', {
        duration: 1000,
      });
    }
  }

  filterFieldCurrencyNameDisplayFn(_currency: Currency) {
    return _currency ? `${_currency.currencyCode}` : undefined;
  }

  getCurrencyFilterKeyDataObservable(pageMeta: Page) {
    pageMeta.serachParam =
      pageMeta.serachParam || pageMeta.serachParam == ''
        ? pageMeta.serachParam
        : this.searchKeyParams;
    this.searchKeyParams = pageMeta.serachParam;
    return from(this.quoteService.getAllCurrenciesByFliterKeyValueByServiceRfqToken(
      pageMeta.serachParam,
      pageMeta.pageNumber || 1,
      pageMeta.size || 10
    ));
  }


  getCurrencyControl(): any {
    return this.firstFormGroup.get('supplierCurrency') as FormControl;
  }

  updateSelectedCountriesFromLocationIds(locationIds: number[]): void {
  this.selectedCountries = this.countries
    .filter(country => locationIds.includes(country.id))
    .map(country => ({
      id: country.id,
      name: country.name
    }));
}


  async getQuoteDraftData() {

    this.fullLoaderService.showLoader()

    const data = await this.quoteService.getServiceQuoteDraftDataByServiceRfqToken('tab1', this.quoteId)

    console.log("data fetched with getServiceQuoteDraftData",data);

    if (data && data.length > 0 && Object.keys(data[0]).length > 0) {

      const buyerAttachments = data[0].buyerAttachments;

      if(buyerAttachments && Array.isArray(buyerAttachments)) {
        buyerAttachments.forEach((attachment:any) => {
          if (attachment.s3_path) {
            this.buyerAttachmentUrl.push(attachment.s3_path);
          }
        });
      }

      console.log("buyerAttachmentUrl", this.buyerAttachmentUrl);

      if(data[0].incoterms){
        this.firstFormGroup.patchValue({
          incoterms: data[0].incoterms,
          incotermLocation: data[0].incotermLocationsID,
        })
        if(data[0].incotermLocationsID!=null){
          this.updateSelectedCountriesFromLocationIds(data[0].incotermLocationsID);
        }

      }


      console.log(data[0].priceGoodUntilDate);

      this.firstFormGroup.patchValue({

        // quote details
      quoteId:data[0].quoteId || null,
      serviceRfqId: data[0].serviceRfqId || null,
      serviceSupplierRfqDetailsId:data[0].supplierRfqId,
      quoteRefNumber: data[0].quoteRefNumber || null,
      priceGoodUntilDate: data[0].pricesGoodUntil || null,
      offeredQuality: data[0].offeredQuality || null,
      onTimeDeliveryOrderDate: data[0].onTimeDeliveryOrderBy || null,
      quotedDeliveryInDays: data[0].quotedDeliveryInDays || null,

      // my details
      supplierId: data[0].supplierId || null,
      supplierContactName: data[0].supplierContactName || null,
      supplierEmail: data[0].supplierEmail || null,
      supplierTelephone: data[0].supplierTelephone ||null,
      supplierMobile: data[0].supplierMobile || null,
      supplierCompanyEmail: data[0].supplierCompanyEmail || null,
      supplierCurrency: data[0].supplierCurrency || null,

      // comment
      supplierComment: data[0].supplierComment || null,
      buyerComment: data[0].buyerComment || null,
      quoteHeaderAttachmentType:data[0].quoteHeaderAttachmentType || null,
      quoteHeaderAttachments:data[0].quoteHeaderAttachments || null,

      // freight forwarder
      quoteFreightForwarderId: data[0].qffId || null,
      freightForwarderDetailsId : data[0].qffDetailsId || null,
      freightForwarderCompanyName: data[0].qffCompanyName || null,
      pic : data[0].qffpic || null,
      freightForwarderJobTitle : data[0].qffjobTitle || null,
      freightForwarderEmailId : data[0].qffemailId || null,
      freightForwarderPhone : data[0].qffphone || null,
      freightForwarderFax : data[0].qfffax || null,
      freightForwarderAddress :data[0].qffaddress || null,
      packaging : data[0].qffpackaging || null,
      modeOfTransport : data[0].qffmodeOfTransport || null


      });


      await this.quoteService.getSupplierUpdateDataByServiceRfqToken()
            .then((res) => {
              console.log("resposne of getSupplierUpdateDatabyUserId",res.data[0]);
              this.firstFormGroup.patchValue({

                supplierId: Number(data[0].supplierId),
                supplierContactName:  res.data[0].companyName,
                supplierEmail: res.data[0].primaryEmail,
                supplierTelephone: res.data[0].phone1,
                supplierMobile: res.data[0].phone1,
                supplierCompanyEmail: res.data[0].primaryEmail,
                supplierCurrency: res.data[0].supplierCurrency,
              });
              this.paymentTermsAndConditions=res.data[0].paymenttermsconditioncolumn;
              this.paymentTermsAndConditionAttachmentUrl=res.data[0].s3_Path;

            })


      this.uploadedAttachmentsArray = data[0].quoteHeaderAttachments;
        if (this.uploadedAttachmentsArray && this.uploadedAttachmentsArray.length > 0) {
          this.supplierAttachmentUrls = this.uploadedAttachmentsArray.map(
            (att: any) => att.url || att.dataUrl
          ).filter((url: string) => !!url);
        }



      this.fullLoaderService.hideLoader()

    }

  }

  fileOver(event: any) {}
  fileLeave(event: any) {}


  toggleSidebar(value:boolean, section:string,index?:number){

    if(section == 'attachment'){
      this.showAddDocumentSection = value
    }


  }

  async onAttachmentChange(files: NgxFileDropEntry[]) {
    try{

      this.newfileuploaded = true;
      this.fullLoaderService.showLoader();
      this.uploadedAttachmentsArray =
      this.firstFormGroup.get('quoteHeaderAttachments')?.value || [];


      if (this.uploadedAttachmentsArray.length > 5) {
        throw new Error('Maximum 5 files allowed for a product!');
      }

      const fileEntries = files
        .filter((entry) => entry.fileEntry.isFile)
        .map((ele) => ele.fileEntry as FileSystemFileEntry);

        console.log(fileEntries,"fileEntries")

      if (fileEntries.length === 0) {
        throw new Error('Please upload valid files!');
      }
      if (fileEntries.length > 5) {
        throw new Error('Maximum 5 files allowed for a product!');
      }

      await new Promise((res, rej) => {
        fileEntries.map((fileEntry) => {
          fileEntry.file(async(file) => {
            let fileExt = file.name.split('.').pop()?.toLowerCase();
            if (!this.acceptedAttachmentExtenstion.includes(`.${fileExt}`)) {
              throw new Error('Invalid file type! Allowed: PDF, JPG, JPEG, PNG');
            }

            if (file.size > this.maxFileSize) {
              throw new Error('File size must be less than 10MB!')
            }

            let uploadedAttachment:any = {
              dataUrl:'',
              name:file.name,
              file:file,
              attachmentType: this.selectedAttachmentType
            }

            await new Promise((res,rej)=>{
              const reader = new FileReader();
              reader.onload = (e: any) => {
                uploadedAttachment.dataUrl = e.target.result;
                res(true)
              };
              reader.readAsDataURL(file);
            })

            this.uploadedAttachmentsArray.push(uploadedAttachment);
            res(file);
          });
        });
      });

      this.firstFormGroup.get('quoteHeaderAttachments')?.setValue(this.uploadedAttachmentsArray);
      this.supplierAttachmentUrls = this.uploadedAttachmentsArray.map(
        (att: any) => att.url || att.dataUrl
      ).filter((url: string) => !!url);

      console.log("uploadedAttachmentsArray",this.uploadedAttachmentsArray);
      this.fullLoaderService.hideLoader();

    } catch (error: any) {
      this.snack.open(error?.message || error, 'OK', { duration: 3000 });
      this.fullLoaderService.hideLoader();
    }
  }


  async downloadDocument(s3_path:string) {
    this.fullLoaderService.showLoader();
    let fileName = s3_path.split("/")[s3_path.split("/").length - 1];
    await this.dataTransferService.downloadFile(s3_path, fileName)
    this.fullLoaderService.hideLoader();
  }



  getIncotermCountryControl(): any {
    return this.firstFormGroup.get('incotermLocation') as FormControl;
  }

  getCountryFilterKeyDataObservable(pageMeta: Page): Observable<any> {
    pageMeta.serachParam =
      pageMeta.serachParam || pageMeta.serachParam == ''
        ? pageMeta.serachParam
        : this.searchKeyParams;
    this.searchKeyParams = pageMeta.serachParam;
    return this.countryDataWithSearch(pageMeta.serachParam)
  }

  countryDataWithSearch(searchText: any) {
    const regex = new RegExp(searchText, 'i');
    return new Observable<any>(observer => {
      let data = JSON.parse(this.ls.getItem('countries'))
      const filteredData = data.filter((item: any) => regex.test(item.name));
      const dataResult = { rows: filteredData }
      observer.next(dataResult);
      observer.complete();
    });
  }

  onCountrySelected(value: AutoCompleteDataType) {

  }


  async rfqActions(action:string){

    if(action == 'download'){

    this.fullLoaderService.showLoader()

    let fileName = this.headerData?.rfqRefNumber +'.pdf';

    const pdf = await this.quoteService.generateSupplierServiceRfqAttachmentByServiceRfqToken(
      this.serviceRfqId,
      Number(this.serviceRfqTokenAuth.getSupplierId())
    )

    const uint8Array = new Uint8Array(pdf.data);
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);


    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    this.fullLoaderService.hideLoader()
    }

    else if(action == 'decline'){

      this.showDeclineConfirmationDialogue = true

    }

    else if(action == 'acknowledge'){

      this.fullLoaderService.showLoader()

      let data = {
        operation:action,
        selectedRfqId : [this.headerData.supplierRfqId]
      }

      await this.quoteService.acknowledgeServiceRfqByServiceRfqToken(data)
      this.fullLoaderService.hideLoader()
      this.snack.open('RFQ has been acknowledged', 'OK', {
        duration: 3000,
      });

      this.fetchServiceRfqDetails()


    }
  }

  toggleBlur(): void {
    const element = document.querySelector('.blurry');
    if (element) {
      element.classList.toggle('blur');
    } else {
      console.warn('Element with class "blurry" not found.');
    }
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.buyerAttachmentUrl.length;
  }

  prevSlide() {
    this.currentIndex =
      (this.currentIndex - 1 + this.buyerAttachmentUrl.length) %
      this.buyerAttachmentUrl.length;
  }

  isPdf(urlOrDataUrl: string): boolean {
    if (urlOrDataUrl?.toLowerCase().startsWith('data:application/pdf')) {
      return true;
    }
    return urlOrDataUrl?.toLowerCase().endsWith('.pdf');
  }

  async toggleHeaderAttachmentImage(value: boolean, url?: any) {
    if(url){
      this.headerAttachmentUrl=url;
    }
    this.toggleBlur();
    this.headerAttachmentSection=value;
  }

  async togglePaymentTermsAndConditionsAttachment(value:boolean){
    this.toggleBlur();
    this.paymentTermsAndConditionsSection = value;
  }
  async toggleBuyerAttachments(value:boolean){
    this.toggleBlur();
    this.buyerAttachmentsSection=value;
  }
  async toggleSupplierAttachments(value:boolean){
    if(value) {
      this.supplierCurrentIndex = 0;
    }
    this.toggleBlur();
    this.supplierAttachmentsSection=value;
  }
  nextSupplierSlide() {
    this.supplierCurrentIndex = (this.supplierCurrentIndex + 1) % this.supplierAttachmentUrls.length;
  }
  prevSupplierSlide() {
    this.supplierCurrentIndex =
      (this.supplierCurrentIndex - 1 + this.supplierAttachmentUrls.length) %
      this.supplierAttachmentUrls.length;
  }
  checkDateClass(date: any): string {

    const dateStr = date.toISOString().split('T')[0];
    const etaDateStr = this.headerData?.vesselEta.toISOString().split('T')[0];
    const etdDateStr = this.headerData?.vesselEtd.toISOString().split('T')[0];

    if (dateStr === etaDateStr) {
      return 'eta-date';
    } else if (dateStr === etdDateStr) {
      return 'etd-date';
    }
    return '';
  }

  async removeAttachment(attachment: any) {

    if(attachment?.attachmentId){

      this.delAttachmentArr.push(attachment.attachmentId)
    }

      this.uploadedAttachmentsArray.splice(
        this.uploadedAttachmentsArray.findIndex((ele) => ele.name === attachment.name),
        1
      );

      this.firstFormGroup.get('quoteHeaderAttachments')?.setValue(this.uploadedAttachmentsArray)
      this.supplierAttachmentUrls = this.uploadedAttachmentsArray.map(
        (att: any) => att.url || att.dataUrl
      ).filter((url: string) => !!url);

      console.log(this.uploadedAttachmentsArray,'uploadedAttachmentsArray')


    this.cdr.detectChanges()
  }

  async renameAttachment(){}

  async saveAttachment(){

    if(this.delAttachmentArr.length > 0){

      this.fullLoaderService.showLoader()
      await this.quoteService.deleteAttachmentByServiceRfqToken(this.delAttachmentArr)
      this.snack.open(`Attachment deleted`, "OK", { duration: 3000 });
      this.fullLoaderService.hideLoader()
    }

    this.showAddDocumentSection = false

  }

  cancelDecline(){
    this.showDeclineConfirmationDialogue = false
    this.declineReason = ''
  }

  async declineRfq(){

      this.fullLoaderService.showLoader()

      this.showDeclineConfirmationDialogue =true
      let data = {
        declineReason:this.declineReason,
        supplierRfqDetailsId : this.headerData.supplierRfqId
      }

      await this.quoteService.declineServiceRfqByServiceRfqToken(data)
      this.fullLoaderService.hideLoader()
      this.showDeclineConfirmationDialogue = false
      this.snack.open('RFQ has been declined', 'OK', {
        duration: 3000,
      });

      this.fetchServiceRfqDetails()

  }

  async saveDraft(isDraft?:boolean){



    this.fullLoaderService.showLoader()

    const dateString1 = this.firstFormGroup.value.quoteDate ? moment(this.firstFormGroup.value.quoteDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
    const dateString2 = this.firstFormGroup.value.priceGoodUntilDate ? moment(this.firstFormGroup.value.priceGoodUntilDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
    const dateString3 = this.firstFormGroup.value.onTimeDeliveryOrderDate ? moment(this.firstFormGroup.value.onTimeDeliveryOrderDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;


    this.firstFormGroup.patchValue({
      quoteDate: dateString1,
      priceGoodUntilDate: dateString2,
      onTimeDeliveryOrderDate: dateString3
    });

      let attachmentFiles:any = {}
      let formObj = this.firstFormGroup.value
      let attachmentArray = [...this.uploadedAttachmentsArray]

      attachmentArray = attachmentArray.filter(item=>item.file)

      // 2026-10-26: the quote reference shown here is the browser's guess (the server assigns the real one on save), so it can
      // name ANOTHER supplier's quote; header files go to a fresh folder of their own. The saved attachment rows decide who
      // may open them (Supplier-API utils/file-access.js).
      let uploadPath = `quotation/upload-${uuidv4()}`

      await Promise.all(attachmentArray.map(async(attachment:any,index:any)=>{
        if(!attachment.file){
              return
        }

            let fileName = attachment.file.name
            let fileExt = attachment.name.slice(
              ((attachment.name.lastIndexOf('.') - 1) >>> 0) + 2
            );

            let fileNameSystem = `${uuidv4()}.${fileExt}`

            attachment.systemName = fileNameSystem
            let s3Location = `${uploadPath}/${fileName}`;

            let _s3Params = {
              fileKey: s3Location,
              fileContentType: (<File>attachment.file).type,
            };
            attachment.s3Params = _s3Params
            attachmentFiles[attachment.file.name] = attachment.file
      }))

          console.log({attachmentArray});
          try {
            const signed = await this.quoteService.getBulkAttachmentUrlsByServiceRfqToken(attachmentArray);
            const uploaded = await completeQuoteHeaderUploads(attachmentArray, signed,
              (url, file) => this.webApiService.putRequestExternalApi(url, file),
              url => this.awsSdkService.extractS3LocationFromUrl(url));
            const saved = this.uploadedAttachmentsArray.filter((item: any) => item && !item.file);
            this.firstFormGroup.get('quoteHeaderAttachments')?.setValue([...saved, ...uploaded]);
          } catch (error) {
            this.fullLoaderService.hideLoader();
            this.snack.open('Attachment upload failed. Please retry.', 'OK', { duration: 5000 });
            return;
          }

        console.log("quoteHeaderAttachments",formObj.quoteHeaderAttachments);


      const params = {
        section: 'tab1',
        quoteId: this.quoteId,
        quoteStatus: isDraft? 14 : 2,
        tabId: 2,
        headerDetails: this.firstFormGroup.value,
        serviceRfqId: this.serviceRfqId
      };

      console.log("Saving firstFormGroup value....",this.firstFormGroup.value);




      if (this.quoteId == 'new' && this.firstFormGroup.get('quoteId')?.value == null) {



        const result = await this.quoteService.saveServiceQuoteAsDraftByServiceRfqToken(params);


        if (result?.data) {

          this.fullLoaderService.hideLoader()

          this.snack.open(`Header Data Saved`, "OK", { duration: 3000 });

          this.isSaved = true;


        } else {
          this.fullLoaderService.hideLoader()
          throw new Error('Invalid response format: Expected { data: number }');
        }

      }
      else if (this.quoteId != 'new' &&
        this.firstFormGroup.get('quoteFreightForwarderId')?.value

      ) {

        const result = await this.quoteService.updateServiceQuoteDraftByServiceRfqToken(params);

        if (result?.data) {

          this.fullLoaderService.hideLoader()

          this.snack.open(`Header Data Saved`, "OK", { duration: 3000 });

          this.isSaved = true;



        } else {
          this.fullLoaderService.hideLoader()
          throw new Error('Invalid response format: Expected { data: number }');
        }

      }

  }





}
